import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { API_BASE_URL } from "../../../config.js";
import EntriesSelector from "../../Pagination/EntriesSelector";
import Pagination from "../../Pagination/Paginations";

const Lead = () => {
  const [records, setRecords] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  /* ---------------- FETCH APPROVAL LIST ---------------- */
  useEffect(() => {
    fetchApprovalList();
  }, []);

  const fetchApprovalList = async () => {
    try {
      const token = localStorage.getItem("authToken");

      const res = await axios.get(`${API_BASE_URL}/approval-list`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      setRecords(res.data.records);
    } catch (err) {
      console.error("Failed to load approval list:", err);
    }
  };

  /* ---------------- SEARCH FILTER ---------------- */
  const filteredItems = records.filter((item) =>
    `${item.employee_id} ${item.employee_name} ${item.incharge_name} ${item.hod_name} ${item.hr_status}`
      .toLowerCase()
      .includes(filterText.toLowerCase())
  );

  /* Pagination (Previous / Next style) */
  const totalPages = Math.ceil(filteredItems.length / perPage);
  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;
  const pageData = filteredItems.slice(indexOfFirst, indexOfLast);

  /* ---------------- DATATABLE COLUMNS ---------------- */
  const columns = [
    {
      name: "Employee ID",
      selector: (row) => row.employee_id,
      sortable: true,
      width: "130px",
    },
    {
      name: "Employee",
      sortable: true,
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={row.profile_picture}
            alt="profile"
            width="40"
            height="40"
            style={{
              borderRadius: "50%",
              objectFit: "cover",
              marginRight: "10px",
            }}
          />
          <span>{row.employee_name}</span>
        </div>
      ),
    },
    {
      name: "Incharge Name",
      selector: (row) => row.incharge_name,
      sortable: true,
    },
    {
      name: "HOD Name",
      selector: (row) => row.hod_name,
      sortable: true,
    },
    {
      name: "HR Status",
      selector: (row) => row.hr_status,
      sortable: true,
      cell: (row) => (
        <span
          className="badge"
          style={{
            backgroundColor: row.hr_status === "HR" ? "#1d3a8a" : "#6c757d",
            color: "#fff",
          }}
        >
          {row.hr_status || "Pending"}
        </span>
      ),
    },
  ];

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        {/* HEADER */}
        <div className="card-header d-flex justify-content-between align-items-center">
      <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
          <path fillRule="evenodd" d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.017-1.694a.5.5 0 1 1 .858.257z"/><path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/><path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1z"/>
        </svg>
        Lead
      </h3>

          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
          <EntriesSelector
            entriesPerPage={perPage}
            setEntriesPerPage={setPerPage}
            setCurrentPage={setCurrentPage}
          />
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Search..."
            style={{ width: "220px" }}
            value={filterText}
            onChange={(e) => { setFilterText(e.target.value); setCurrentPage(1); }}
          />
          </div>
        </div>

        {/* TABLE */}
        <div className="card-body">
          <DataTable
            columns={columns}
            data={pageData}
            highlightOnHover
            striped
            responsive
          />
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default Lead;
